import React from 'react'
import styled from 'styled-components'
import { Alert } from './Alert'

interface Props {
  isDisabled: boolean
  children: React.ReactNode
}

export const DisableContainer: React.FC<Props> = ({ isDisabled, children }) => {
  return (
    <>
      <Alert type="info" title="Tapahtuma on lukittu" isVisible={isDisabled}></Alert>
      <ContentWrapper $disabled={isDisabled}>
        <form>
          <fieldset disabled={isDisabled}>{children}</fieldset>
        </form>
      </ContentWrapper>
    </>
  )
}

const ContentWrapper = styled.div<{ $disabled: boolean }>`
  margin-top: ${({ $disabled }) => ($disabled ? '16px' : 0)};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'initial')};
  user-select: ${({ $disabled }) => ($disabled ? 'none' : 'initial')};
  opacity: ${({ $disabled }) => ($disabled ? 0.75 : 1)};
`
